/* debora-atc.js (Modernized)
   PURPOSE: Universal, theme-agnostic Add-to-Cart for Debora recommendation cards.
   IMPROVEMENTS: No jQuery, Modern Async/Await, Robust Error Handling.
*/

(function () {
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    function dispatchCartEvent(name, detail) {
        const payload = detail || {};
        // Dispatch to document and window to be safe
        document.dispatchEvent(new CustomEvent(name, { detail: payload, bubbles: true }));
        window.dispatchEvent(new CustomEvent(name, { detail: payload, bubbles: true }));
    }

    async function fetchCartJSON() {
        try {
            const res = await fetch('/cart.js', { credentials: 'same-origin' });
            if (!res.ok) return null;
            return await res.json();
        } catch (err) {
            console.warn('[Debora ATC] cart fetch failed', err);
            return null;
        }
    }

    // Define global function if not exists
    if (typeof window.addToCartByHandle !== 'function') {
        window.addToCartByHandle = async function addToCartByHandle(handle, opts) {
            if (!handle) return null;

            const options = opts || {};
            const qty = Number(options.qty || 1) > 0 ? Number(options.qty || 1) : 1;
            let variantId = options.variantId ? String(options.variantId) : '';

            try {
                // 1. Resolve Variant ID if missing
                if (!variantId) {
                    const encodedHandle = encodeURIComponent(handle);
                    const res = await fetch(`/products/${encodedHandle}.js`, { credentials: 'same-origin' });
                    if (!res.ok) throw new Error('product_fetch_failed');
                    const product = await res.json();
                    // Find first available or default
                    const variant = (product.variants || []).find(v => v.available) || (product.variants || [])[0];
                    if (!variant) throw new Error('variant_not_found');
                    variantId = String(variant.id);
                }

                // 2. Add to Cart
                const addRes = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: variantId, quantity: qty })
                });
                if (!addRes.ok) throw new Error('cart_add_failed');

                let added = null;
                try { added = await addRes.json(); } catch (_) { }

                // 3. Refresh & Dispatch
                const cartData = await fetchCartJSON();
                const detail = { item: added, cart: cartData, source: 'debora', handle };

                dispatchCartEvent('cart:refresh', detail);
                dispatchCartEvent('ajaxCart:refresh', detail); // Common theme event

                // Open Drawer (Generic Class)
                if (document.documentElement) {
                    document.documentElement.classList.add('cart-drawer-open');
                }

                // Dispatch Money Update
                document.dispatchEvent(new Event('money:update', { bubbles: true }));

                // 4. Fire Analytics Event (Captured by debora-analytics.js)
                document.dispatchEvent(new CustomEvent('debora:cart:added', { detail }));

                console.log('[Debora ATC] Added', handle);
                return added;

            } catch (error) {
                console.warn('[Debora ATC] addToCartByHandle failed', error);
                throw error;
            }
        };
    }

    // Delegated Click Handler
    async function handleClick(evt) {
        const btn = evt.target.closest('[data-debora-atc], .debora-card .atc, .d-card__atc');
        if (!btn) return;

        const handle = btn.getAttribute('data-handle') || btn.dataset.handle || '';
        if (!handle) return;

        evt.preventDefault();
        if (btn.dataset.loading === '1') return; // Debounce

        // Visual State: Loading
        btn.dataset.loading = '1';
        btn.setAttribute('aria-busy', 'true');
        btn.setAttribute('disabled', 'disabled');

        const qty = Number(btn.dataset.qty || btn.getAttribute('data-qty') || '1') || 1;
        const variantId = btn.dataset.variantId || btn.getAttribute('data-variant-id') || '';

        try {
            await window.addToCartByHandle(handle, { qty, variantId });

            // Visual State: Success
            btn.dataset.loading = '0';
            btn.classList.add('is-added', 'is-just-added');

            const text = btn.querySelector('.button__text');
            if (text) text.classList.add('is-added');

            // Reset after delay
            setTimeout(() => {
                btn.classList.remove('is-just-added');
                if (text) text.classList.remove('is-just-added');
            }, 1500);

        } catch (error) {
            // Visual State: Error
            btn.dataset.loading = '0';
            btn.classList.add('is-error');
            console.error(error);
            await sleep(1500);
            btn.classList.remove('is-error');
        }

        btn.removeAttribute('aria-busy');
        btn.removeAttribute('disabled');
    }

    document.addEventListener('click', handleClick);
})();
